import { typedQueryClient, useTypedMutation } from "hooks";
import { AgreementsDashboardQueryKeys } from "modules/AgreementsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

export type CreateEditAgreementPayload = {
  id: number;
  dealer_id: number;
  name: string;
  text: string;
  visible_online_check_in: boolean;
  visible_keylocker_check_in: boolean;
  visible_kiosk_check_in: boolean;
  visible_desk_check_in: boolean;
  visible_desk_check_out: boolean;
  visible_customcom: boolean;
  optional_online_check_in: boolean;
  optional_keylocker_check_in: boolean;
  optional_kiosk_check_in: boolean;
  optional_desk_check_in: boolean;
  optional_desk_check_out: boolean;
  optional_customcom: boolean;
};

export const useCreateAgreementMutation = () =>
  useTypedMutation<CreateEditAgreementPayload, number>({
    mutationFn: async payload => (await ApiInstance.post("/check_in/agreement/create", payload)).data.id,
    onSuccess: (payload, id) => {
      const agreements = typedQueryClient.getQueryData(AgreementsDashboardQueryKeys.list);
      const now = toISOString(new Date());

      typedQueryClient.setQueryData(AgreementsDashboardQueryKeys.list, [
        ...(agreements ?? []),
        { ...payload, id, parent_id: null, deleted: false, created_on: now, updated_on: now }
      ]);
    }
  });
